export const USER_SETTINGS_KEY = "mhw_user-settings_1_0"
